import { trackFrontendApisClientSideErrorError } from "@faire/web-api/events/frontendApis/error/clientSideError";
import { getGlobalProperty } from "@faire/web/common/globals/getGlobalProperty";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import * as React from "react";
import { useEffect } from "react";
import styled from "styled-components";

import { ShopOurCategories } from "@faire/retailer/components/ShopOurCategories";

const Container = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Title = styled(Typography).attrs({
  align: "center",
  variant: "displayLSerifRegular",
})`
  &&& {
    padding: 60px 30px 30px;
    line-height: 30px;
    font-weight: 300;
    font-size: 40px;

    ${responsiveMediaQueries.mobile} {
      font-size: 30px;
    }
  }
`;

const Subtitle = styled(Typography).attrs({
  align: "center",
  variant: "displaySSansSemiBold",
})`
  &&& {
    line-height: 30px;
    padding: 0 20px;
    font-weight: 300;
    font-size: 20px;

    ${responsiveMediaQueries.mobile} {
      font-size: 16px;
    }
  }
`;

export const PageNotFound: React.FC = () => {
  useEffect(() => {
    trackFrontendApisClientSideErrorError(
      "Page not found",
      getGlobalProperty("isNextJS") ? "NEXT_JS" : "SPA",
      getGlobalProperty("originalUrl"),
      getGlobalProperty("processingServer")
    );
  }, []);
  return (
    <Container>
      <Title data-test-id="page-not-found-header">
        <StrictLocalMsg defaultMessage="Page not found" />
      </Title>
      <Subtitle data-test-id="page-not-found-text">
        <StrictLocalMsg defaultMessage="Can we help you find some new products instead?" />
      </Subtitle>
      <ShopOurCategories />
    </Container>
  );
};
